import { useQuery } from "@tanstack/react-query";
import { exchangeOAuthCodeForToken } from "@/firebase";
import { useSearchParams } from "react-router-dom";
import React from "react";
import { CircularProgress } from "@mui/material";

function OAuthCallback() {
  const [searchParams] = useSearchParams();

  const query = useQuery({
    queryKey: ["oauth-callback"],
    queryFn: async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const error = searchParams.get("error");

      const isPopup = window.opener && !window.opener.closed;
      console.log("queryState", {
        code,
        state,
        error,
        isPopup,
      });

      if (error) {
        if (isPopup) {
          window.opener.postMessage(
            { type: "OAUTH_ERROR", error },
            window.location.origin
          );
          window.close();
        }
        return;
      }

      if (!code) {
        if (isPopup) {
          window.opener.postMessage(
            { type: "OAUTH_ERROR", error: "Invalid request" },
            window.location.origin
          );
          window.close();
        }
        return;
      }
      console.log("Exchange code for token:", code);

      try {
        const token = await exchangeOAuthCodeForToken({ code });
        if (isPopup) {
          window.opener.postMessage(
            { type: "OAUTH_SUCCESS" },
            window.location.origin
          );
          window.close();
        }
        return token;
      } catch (e) {
        if (isPopup) {
          window.opener.postMessage(
            { type: "OAUTH_ERROR", error: "Exchange failed" },
            window.location.origin
          );
          window.close();
        }
      }
    },
    retry: false,
  });

  return (
    <div className="flex flex-col h-screen items-center justify-center">
      {query.isLoading && (
        <div className="text-center">
          <CircularProgress />
          <p className="text-lg font-semibold">Authorizing...</p>
          <p className="text-sm text-gray-600">
            Please wait while we authorize your account.
          </p>
        </div>
      )}
      {query.error && (
        <div>
          <p>Something went wrong</p>
        </div>
      )}
    </div>
  );
}

export default OAuthCallback;
